import { BrowserRouter, Routes, Route } from 'react-router-dom';
import SiteLayout from './layouts/SiteLayout';
import Home from './pages/Home';
import Services from './pages/Services';
import Solutions from './pages/Solutions';
import Resources from './pages/Resources';
import Support from './pages/Support';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Engine from './pages/services/Engine';
import Transmission from './pages/services/Transmission';
import Suspension from './pages/services/Suspension';
import Glass from './pages/services/Glass';
import Body from './pages/services/Body';
import Electrical from './pages/services/Electrical';
import AC from './pages/services/AC';
import Programming from './pages/services/Programming';
import Aftermarket from './pages/services/Aftermarket';
import Tint from './pages/services/Tint';

export default function App() {
	return (
		<BrowserRouter>
			<Routes>
				<Route element={<SiteLayout />}>
					<Route index element={<Home />} />
					<Route path="services" element={<Services />} />
					<Route path="services/engine" element={<Engine />} />
					<Route path="services/transmission" element={<Transmission />} />
					<Route path="services/suspension" element={<Suspension />} />
					<Route path="services/glass" element={<Glass />} />
					<Route path="services/body" element={<Body />} />
					<Route path="services/electrical" element={<Electrical />} />
					<Route path="services/ac" element={<AC />} />
					<Route path="services/programming" element={<Programming />} />
					<Route path="services/aftermarket" element={<Aftermarket />} />
					<Route path="services/tint" element={<Tint />} />
					<Route path="solutions" element={<Solutions />} />
					<Route path="resources" element={<Resources />} />
					<Route path="support" element={<Support />} />
					<Route path="contact" element={<Contact />} />
					<Route path="privacy" element={<Privacy />} />
					<Route path="terms" element={<Terms />} />
				</Route>
			</Routes>
		</BrowserRouter>
	);
}
